import React from 'react';

const Door: React.FC = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 100 100" {...props}>
    <circle cx="49.5" cy="49.5" r="47" stroke="currentColor" strokeWidth="5"></circle>
    <path
      fill="currentColor"
      d="M61.177 51.083a2.167 2.167 0 00-2.167 2.167v12.458a.542.542 0 01-.542.542h-5.416a.542.542 0 01-.542-.542V36.593a3.235 3.235 0 00-1.796-2.906l-2.136-1.07a.54.54 0 01.24-1.034h10.183a2.167 2.167 0 100-4.333H37.335a2.192 2.192 0 00-2.167 2.167v38.35a3.25 3.25 0 001.796 2.907l10.834 5.417a3.25 3.25 0 004.7-2.908v-2.039a.541.541 0 01.54-.541h7.042a3.25 3.25 0 003.25-3.25V53.25a2.167 2.167 0 00-2.153-2.167z"
    ></path>
  </svg>
);

export default Door;
